import React from 'react'
import './terms.css'
import Navbar from './../../components/navbar/Navbar';
import Hero from './../../components/hero/Hero';

const Terms = () => {
  return (
      <>
        <Navbar/>
        <Hero title="Our Terms And Conditions"/>
      </>
  )
}

export default Terms